"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const ui = __importStar(require("@mwater/react-library/lib/bootstrap"));
const AxisComponent_1 = __importDefault(require("../../../axes/AxisComponent"));
const ColorComponent_1 = __importDefault(require("../../../ColorComponent"));
const expressions_ui_1 = require("@mwater/expressions-ui");
const expressions_ui_2 = require("@mwater/expressions-ui");
const bootstrap_1 = require("@mwater/react-library/lib/bootstrap");
const __1 = require("../../..");
const PopoverHelpComponent_1 = __importDefault(require("@mwater/react-library/lib/PopoverHelpComponent"));
// Design a single segment of a pivot table
class SegmentDesignerComponent extends react_1.default.Component {
    labelElem;
    constructor(props) {
        super(props);
        this.state = {
            // Mode switcher to make UI clearer
            mode: props.segment.label == null && !props.segment.valueAxis ? null : props.segment.valueAxis ? "multiple" : "single"
        };
    }
    componentDidMount() {
        return this.labelElem?.focus();
    }
    // Updates segment with the specified changes
    update(changes) {
        const segment = lodash_1.default.extend({}, this.props.segment, changes);
        return this.props.onChange(segment);
    }
    handleMode = (mode) => {
        this.update({ valueAxis: null });
        return this.setState({ mode });
    };
    handleValueAxisChange = (valueAxis) => {
        return this.update({ valueAxis });
    };
    handleValueAxisOnlyValuesPresentChange = (valueAxisOnlyValuesPresent) => {
        return this.update({ valueAxisOnlyValuesPresent });
    };
    handleLabelChange = (ev) => {
        return this.update({ label: ev.target.value });
    };
    handleFilterChange = (filter) => {
        return this.update({ filter });
    };
    handleOrderExprChange = (orderExpr) => {
        return this.update({ orderExpr });
    };
    handleOrderDirChange = (orderDir) => {
        return this.update({ orderDir });
    };
    renderMode() {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Type` },
            react_1.default.createElement(ui.Radio, { key: "single", value: this.state.mode, radioValue: "single", onChange: this.handleMode },
                T `Single ${this.props.segmentType}`,
                react_1.default.createElement("span", { className: "text-muted" },
                    ` - `,
                    T `used for summary ${this.props.segmentType}s and empty ${this.props.segmentType}s`)),
            react_1.default.createElement(ui.Radio, { key: "multiple", value: this.state.mode, radioValue: "multiple", onChange: this.handleMode },
                T `Multiple ${this.props.segmentType}s`,
                " - ",
                react_1.default.createElement("span", { className: "text-muted" }, T `disaggregate data by a field`))));
    }
    renderLabel() {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Label`, help: this.state.mode === "multiple" ? T `Optional label for the ${this.props.segmentType}s` : undefined },
            react_1.default.createElement("input", { ref: (elem) => {
                    this.labelElem = elem;
                }, type: "text", className: "form-control", value: this.props.segment.label || "", onChange: this.handleLabelChange })));
    }
    renderValueAxis() {
        // Get type of axis
        const axisBuilder = new __1.AxisBuilder({ schema: this.props.schema });
        const axisType = axisBuilder.getAxisType(this.props.segment.valueAxis);
        const allowValueAxisOnlyValuesPresent = axisType == "enum" || axisType == "enumset" || axisType == "date";
        return react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Field`, help: T `Field to disaggregate data by` },
            react_1.default.createElement("div", { style: { marginLeft: 8 } },
                react_1.default.createElement(AxisComponent_1.default, { schema: this.props.schema, dataSource: this.props.dataSource, table: this.props.table, types: ["enum", "enumset", "text", "boolean", "date"], aggrNeed: "none", value: this.props.segment.valueAxis, onChange: this.handleValueAxisChange, allowExcludedValues: true, filters: this.props.filters, collapseCategories: true }),
                allowValueAxisOnlyValuesPresent ?
                    react_1.default.createElement(ui.Checkbox, { value: this.props.segment.valueAxisOnlyValuesPresent, onChange: this.handleValueAxisOnlyValuesPresentChange },
                        T `Only show values actually present`,
                        "\u00A0",
                        react_1.default.createElement(PopoverHelpComponent_1.default, { placement: "bottom" }, T `Limits values to those that are present in the data, as opposed
              to all choices or all dates within range`))
                    : null));
    }
    renderFilter() {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui.Icon, { id: "glyphicon-filter" }),
                " ",
                T `Filters`), hint: T `Filters all data associated with this ${this.props.segmentType}` },
            react_1.default.createElement(expressions_ui_2.FilterExprComponent, { schema: this.props.schema, dataSource: this.props.dataSource, onChange: this.handleFilterChange, table: this.props.table, value: this.props.segment.filter })));
    }
    renderStyling() {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Styling` },
            react_1.default.createElement("div", null,
                react_1.default.createElement(ui.Checkbox, { key: "bold", inline: true, value: this.props.segment.bold === true, onChange: (value) => this.update({ bold: value }) }, T `Bold`),
                react_1.default.createElement(ui.Checkbox, { key: "italic", inline: true, value: this.props.segment.italic === true, onChange: (value) => this.update({ italic: value }) }, T `Italic`),
                this.props.segment.valueAxis && this.props.segment.label ?
                    react_1.default.createElement(ui.Checkbox, { key: "valueLabelBold", inline: true, value: this.props.segment.valueLabelBold === true, onChange: (value) => this.update({ valueLabelBold: value }) }, T `Header Bold`)
                    : undefined,
                this.props.segment.valueAxis && this.props.segment.label ? (react_1.default.createElement("div", { style: { paddingTop: 5 } },
                    T `Shade filler cells: `,
                    react_1.default.createElement(ColorComponent_1.default, { color: this.props.segment.fillerColor, onChange: (color) => this.update({ fillerColor: color }) }))) : undefined)));
    }
    renderBorders() {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Borders` },
            react_1.default.createElement("div", { key: "before" }, this.props.segmentType === "row" ? T `Top: ` : T `Left: `),
            react_1.default.createElement(BorderComponent, { value: this.props.segment.borderBefore, defaultValue: 2, onChange: (value) => this.update({ borderBefore: value }) }),
            react_1.default.createElement("div", { key: "within" }, T `Within: `),
            react_1.default.createElement(BorderComponent, { value: this.props.segment.borderWithin, defaultValue: 1, onChange: (value) => this.update({ borderWithin: value }) }),
            react_1.default.createElement("div", { key: "after" }, this.props.segmentType === "row" ? T `Bottom: ` : T `Right: `),
            react_1.default.createElement(BorderComponent, { value: this.props.segment.borderAfter, defaultValue: 2, onChange: (value) => this.update({ borderAfter: value }) })));
    }
    renderOrderExpr() {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui.Icon, { id: "fa-sort-amount-asc" }),
                " ",
                T `Sort`), hint: T `Sorts the display of this ${this.props.segmentType}` },
            react_1.default.createElement(expressions_ui_1.ExprComponent, { schema: this.props.schema, dataSource: this.props.dataSource, onChange: this.handleOrderExprChange, table: this.props.table, types: ["enum", "text", "boolean", "date", "datetime", "number"], aggrStatuses: ["aggregate"], value: this.props.segment.orderExpr ?? null }),
            this.props.segment.orderExpr ? (react_1.default.createElement("div", null,
                react_1.default.createElement(ui.Radio, { value: this.props.segment.orderDir || "asc", radioValue: "asc", onChange: this.handleOrderDirChange, inline: true }, T `Ascending`),
                react_1.default.createElement(ui.Radio, { value: this.props.segment.orderDir || "asc", radioValue: "desc", onChange: this.handleOrderDirChange, inline: true }, T `Descending`))) : undefined));
    }
    render() {
        return (react_1.default.createElement("div", null,
            this.renderMode(),
            this.state.mode ? this.renderLabel() : undefined,
            this.state.mode === "multiple" ? this.renderValueAxis() : undefined,
            this.state.mode ? this.renderFilter() : undefined,
            this.state.mode === "multiple" ? this.renderOrderExpr() : undefined,
            this.state.mode ? this.renderStyling() : undefined,
            this.state.mode ? this.renderBorders() : undefined));
    }
}
exports.default = SegmentDesignerComponent;
// Allows setting border heaviness
class BorderComponent extends react_1.default.Component {
    render() {
        const value = this.props.value != null ? this.props.value : this.props.defaultValue;
        return (react_1.default.createElement("span", null,
            react_1.default.createElement(bootstrap_1.Radio, { inline: true, value: value, radioValue: 0, onChange: () => this.props.onChange(0) }, T `None`),
            react_1.default.createElement(bootstrap_1.Radio, { inline: true, value: value, radioValue: 1, onChange: () => this.props.onChange(1) }, T `Light`),
            react_1.default.createElement(bootstrap_1.Radio, { inline: true, value: value, radioValue: 2, onChange: () => this.props.onChange(2) }, T `Medium`),
            react_1.default.createElement(bootstrap_1.Radio, { inline: true, value: value, radioValue: 3, onChange: () => this.props.onChange(3) }, T `Heavy`)));
    }
}
